jQuery(document).ready(function($){
    $('a[href^="#"]').on('click', function(e){
        const element = $( $(this).attr('href') );
        
        if (element.length > 0) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: element.offset().top - 100
            }, 800);
        }
    });
});